import { Provider } from "react-redux";
import "./App.css";
import { store } from "./redux/store";
import { Navigation } from "./components/layout/Navigation";
import { Hero } from "./components/section/Hero";
import { About } from "./components/section/About";
import { Footer } from "./components/layout/Footer";
import { Contact } from "./components/section/Contact";
import { Products } from "./components/section/Product";
import { Features } from "./components/section/Features";

const App = () => {
  return (
    <Provider store={store}>
      <style>{`
        @keyframes slideIn {
          from {
            transform: scaleX(0);
          }
          to {
            transform: scaleX(1);
          }
        }
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        html {
          scroll-behavior: smooth;
        }
      `}</style>
      <div className="font-sans">
        <Navigation />
        <Hero />
        <About />
        <Products />
        <Features />
        {/* <Gallery /> */}
        <Contact />
        <Footer />
      </div>
    </Provider>
  );
};
export default App;
